// extracted by mini-css-extract-plugin
export default {"sliderBox":"index_sliderBox_RGJ8G","slide":"index_slide_h63Uz","dot":"index_dot_5WV64","current":"index_current_ekNgl index_dot_5WV64"};